import React from 'react'
import { getLoggedInUserInfo, capitalizeFirstLetter } from 'utils'
import UserMenu from './UserMenu'
// import NotificationBell from './UserMenu/Notificaton'

// import Cart from './Cart'
import style from './style.module.scss'

const TopBar = () => {
  const user = getLoggedInUserInfo()
  return (
    <div
      className={`d-sm-flex  d-md-flex justify-content-between justify-content-lg-end ${style.topbar}`}
    >
      {/* <NotificationBell /> */}
      <strong className={style.userName}>
        Hello, {(user?.userName && capitalizeFirstLetter(user.userName)) || 'Anonymous'} (
        {user?.empId})
      </strong>
      <div className="topbarRight">
        <UserMenu />
      </div>
    </div>
  )
}

export default TopBar
